<template>
  <v-card>
    <v-container fluid class="pt-2 pb-2">
      <v-row>
        <v-col cols="12" offset-md="2" v-if="isFirst && isMultipleLocation">
          <product-name :product="product"></product-name>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="2">
          <v-row>
            <v-col cols="12" md="6" class="text-md-right">
              <v-chip
                color="warning"
                text-color="white"
                v-if="product.location_product && isShowAction"
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="white" dark v-html="actionIcon.icon"></v-icon>
                  </template>
                  <span v-html="actionIcon.tooltip"></span>
                </v-tooltip>
              </v-chip>

              <v-chip
                text-color="white"
                :color="expiredIn() > 0 ? 'yellow darken-1' : 'red darken-1'"
                v-if="product.expired_at && expiredIn() <= 30"
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="white" dark>mdi-clock</v-icon>
                  </template>
                  <span>Expired in {{ expiredIn() }} days</span>
                </v-tooltip>
              </v-chip>

              <v-chip
                color="cyan"
                text-color="white"
                v-if="product.location_product && parseInt(product.location_product.shelf_time) <= 14"
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="white" dark>mdi-new-box</v-icon>
                  </template>
                  <span>This product is on shelf {{product.location_product.shelf_time}} days ago</span>
                </v-tooltip>
              </v-chip>
            </v-col>
            <v-col cols="12" md="6">
              <v-col>
                <div class="product-image">
                  <img :src="getProductThumbnail(product, locationData.product_list_folder)" @error.once="thumbnailFallback($event, product, locationData.product_list_folder)">
                </div>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="10">
          <v-row>
            <v-col cols="12" md="6">
              <product-name
                v-if="!isMultipleLocation"
                :product="product"
              ></product-name>
              <div v-if="isMultipleLocation">
                <v-chip
                  text-color="white"
                  small
                  class="toolbar__title"
                  :color="locationData.color + ' darken-2'"
                  style="width:100%"
                >
                  <b>{{locationData.ssh_port}} - {{locationData.name}}</b>&nbsp;
                  <router-link
                    :to="{ name: 'Location', params: { id: locationData.id }}"
                    target="_blank"
                    @click.native.stop=""
                    class="icon-link"
                  >
                    <v-icon small color="white">mdi-open-in-new</v-icon>
                  </router-link>
                </v-chip>
              </div>
              <coil-table
                :product="product"
                :locationData="locationData"
                :allProducts="allProducts"
              ></coil-table>
            </v-col>
            <v-col cols="12" md="6">
              <detail
                :product="product"
                :locationData="locationData"
              ></detail>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment-timezone'

import productMixin from '@/mixins/product'
import dateMixin from '@/mixins/date'

import ProductName from '@/components/Common/Rental/Locations/Products/LocationProduct/ProductName'
import CoilTable from '@/components/Common/Rental/Locations/Products/LocationProduct/CoilTable'
import Detail from '@/components/Common/Rental/Locations/Products/LocationProduct/Detail'

export default {
  props: {
    product: Object,
    locationData: Object,
    isMultipleLocation: Boolean,
    isFirst: Boolean,
    allProducts: Array
  },

  mixins: [
    productMixin,
    dateMixin
  ],

  components: {
    ProductName,
    CoilTable,
    Detail
  },

  data () {
    return {
    }
  },

  computed: {
    actionIcon: function () {
      switch (this.product.location_product.action) {
        case 'add':
          return {
            icon: 'mdi-database-plus',
            tooltip: 'This product is selling well, please add 1 coil to this product'
          }
        case 'reduce':
          return {
            icon: 'mdi-database-minus',
            tooltip: 'This product has excess coil, please consider to reduce 1 coil from this product'
          }
        case 'change':
          return {
            icon: 'mdi-sync',
            tooltip: 'The sales of this product is bad, please consider to switch to other products'
          }
      }
    },

    isShowAction () {
      let today = moment.tz(moment(), 'Asia/Hong_Kong')
      return false && (
        this.product.location_product.action !== 'nothing' &&
        parseInt(this.product.location_product.shelf_time) > 14 &&
        (
          !this.product.location_product.capacity_changed_at ||
          today.diff(moment.unix(this.product.location_product.capacity_changed_at).utc().tz('Asia/Hong_Kong'), 'days') >= 30
        ) &&
        (
          !this.product.location_product.product_change_requested_at ||
          today.diff(moment.unix(this.product.location_product.product_change_requested_at).utc().tz('Asia/Hong_Kong'), 'days') >= 30
        )
      )
    }
  },

  methods: {
    expiredIn () {
      return this.daysToGo(this.product.location_product.expired_at)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .product-image
    width: 70px
    height: 70px

    img
      width: 100%
      height: 100%
      object-fit: contain
</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Products/LocationProduct.vue